export const URL_API = 'https://api.themoviedb.org/3'
export const API = 'c7e318bc4679faa16a6f940e1435e019'